import { request as __request } from '../core/request.js';
export class BundleSelectionsService {
    /**
     * Get an account's bundle selection
     * Returns the account's bundle selection.
     *
     * When orders are placed without explicity setting bundle selections, the account's bundle selection is used.
     *
     * Account bundle selections can be set via the API or Dashboard.
     *
     * Every account is created with default bundle selections.
     *
     * @returns BundleSelection The response returns the account's bundle selections
     */
    getBundleSelection() {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/bundle-selections',
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Update an account's bundle selection
     * Set the account's bundle selection.
     *
     * Every account is created with default bundle selections. This will override default bundle selections.
     *
     * @param requestBody
     * @returns BundleSelection The response returns the new account's bundle selections
     */
    updateBundleSelection(requestBody) {
        return __request(this.client, this.config, {
            method: 'PUT',
            url: '/bundle-selections',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized. The API Key is invalid or disabled.`,
                403: `Forbidden. The API Key is not authorized to perform the operation.`,
                409: `Conflict`,
                429: `Rate limit exceeded`,
            },
        });
    }
}
//# sourceMappingURL=BundleSelectionsService.js.map